module.exports = __webpack_public_path__ + "static/media/my_assets_questionnaire.11843856.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/my_assets_questionnaire.png
// module id = 749
// module chunks = 0 1